module.exports = __webpack_public_path__ + "static/support-ec48063bf4e1f9de44eefb0bf3f68dbe.jpg";